/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { cn } from '@/lib/utils';

export const KahuRowPromptWrapper = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'flex w-fit max-w-full gap-2 [contain-intrinsic-size:auto_80px] [content-visibility:auto]',
        className
      )}
    >
      <div className="min-w-0">{children}</div>
    </div>
  );
};
